/**
 * Native base64 helpers — drop-in replacement for the former `base-64` package.
 *
 * Uses the browser-native `btoa`/`atob`, which have identical Latin1 semantics
 * to the `base-64` library: both operate on the 0x00–0xFF range and throw on
 * characters outside it. Non-Latin input (e.g. `€`, Cyrillic, CJK) throws, matching
 * the previous behaviour exactly.
 */

export const encode = (value: string): string => btoa(value);

export const decode = (value: string): string => atob(value);
